var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag,
    {
      tag: "component",
      class: [
        "z-list",
        "z-list--" + this.tag,
        ((_obj = {}), (_obj["z-list--theme-" + this.theme] = this.theme), _obj),
      ],
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }